module.exports = __webpack_public_path__ + "assets/img/solutions5.74f27539.png";